import { api } from 'redux/api/index.api';

const rootProjectPath = 'apikeys/users';

export const apiKeyGeneratorApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchApiKey: builder.query({
      query: () => ({
        url: rootProjectPath,
        method: 'GET',
      }),
    }),
    createApiKey: builder.mutation({
      query: data => ({
        url: rootProjectPath,
        method: 'POST',
        body: {
          name: data.name,
          email: data.email,
        },
      }),
    }),
    deleteApiKey: builder.mutation({
      query: () => ({
        url: rootProjectPath,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const { useFetchApiKeyQuery, useCreateApiKeyMutation, useDeleteApiKeyMutation } = api;
